// smartreader-frontend/src/services/alerts-socket.js
import { io } from 'socket.io-client';

export const connectAlertsSocket = (onMessage) => {
  const socketConfig = { path: '/socket.io', namespace: '/alerts', withCredentials: true };
  const { namespace, ...options } = socketConfig;
  const socket = io(namespace, options);

  const handleAlert = (payload) => {
    try {
      const data = typeof payload === 'string' ? JSON.parse(payload) : payload;
      if (onMessage) onMessage(data);
    } catch (e) {
      // ignore malformed messages
    }
  };

  socket.on('alert', handleAlert);

  return socket;
};

const alertsSocket = { connectAlertsSocket };
export default alertsSocket;
